import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeLayout from '@/components/homelayouts/Layout'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/home'
  },
  //高考小智
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/views/chat/'),
    meta: {
      keepAlive: true,
      title: "高考小梦"
    }
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/homeindex',
    component: HomeLayout,
    children: [{
        // 课程首页
        path: '/homeindex',
        name: 'homeindex',
        component: () => import('@/views/home/Index'),
        meta: {
          keepAlive: false,
          title: "圆梦高考-2025年面向山东省高考志愿填报平台"
        }
      },
      // 填志愿
      {
        path: '/volunteer',
        name: 'volunteer',
        component: () => import('@/views/volunteer/Index'),
        meta: {
          keepAlive: false,
          title: "手动填报填志愿"
        }
      },
      // AI填志愿
      {
        path: '/AIform',
        name: 'AIform',
        component: () => import('@/views/volunteer/AIform.vue'),
        meta: {
          keepAlive: false,
          title: "AI填报志愿"
        }
      },
      // 查学校
      {
        path: '/school',
        name: 'school',
        component: () => import('@/views/school/Index'),
        meta: {
          keepAlive: false,
          title: "查学校"
        }
      },
      // 学校详情
      {
        path: '/school/detail',
        name: 'schoolDetail',
        component: () => import('@/views/school/detail'),
        meta: {
          keepAlive: false,
          title: "学校详情"
        }
      },
      //用户协议
      {
        path: '/userAgreement/userAgreement',
        name: 'userAgreement',
        component: () => import('@/views/userAgreement/userAgreement'),
        meta: {
          keepAlive: false,
          title: "用户协议"
        }
      },
      // 查专业
      {
        path: '/specialty',
        name: 'specialty',
        component: () => import('@/views/specialty/Index'),
        meta: {
          keepAlive: false,
          title: "查专业"
        }
      },
      // 专业详情
      {
        path: '/specialty/detail',
        name: 'specialtyDetail',
        component: () => import('@/views/specialty/detail'),
        meta: {
          keepAlive: false,
          title: "专业详情"
        }
      },
      // 学校/专业搜索
      {
        path: '/search',
        name: 'search',
        component: () => import('@/views/search/search'),
        meta: {
          keepAlive: false,
          title: "学校/专业搜索"
        }
      },
      // 百问百答
      {
        path: '/questions',
        name: 'questions',
        component: () => import('@/views/questions/questions'),
        meta: {
          keepAlive: true,
          title: "百问百答"
        }
      },
      // 问题详情
      {
        path: '/quesdetail',
        name: 'quesdetail',
        component: () => import('@/views/questions/quesdetail'),
        meta: {
          keepAlive: false,
          title: "问题详情"
        }
      },

      // 专家服务
      {
        path: '/expert',
        name: 'expert',
        component: () => import('@/views/expert/Index'),
        meta: {
          keepAlive: false,
          title: "老师预约"
        }
      },
      {
        path: '/expert/detail',
        name: 'detail',
        component: () => import('@/views/expert/detail'),
        meta: {
          keepAlive: false,
          title: "老师详情"
        }
      },
      // 职业测评
      {
        path: '/appraisal',
        name: 'appraisal',
        component: () => import('@/views/appraisal/IndexCopy'),
        meta: {
          keepAlive: false,
          title: "职业测评"
        }
      },
        //资讯管理
      {
        path: '/information',
        name: 'information',
        component: () => import('@/views/information/Index'),
        meta: {
          keepAlive: false,
          title: "高考资讯"
        }
      },
      //资讯列表
      {
        path: '/information/list',
        name: 'list',
        component: () => import('@/views/information/list'),
        meta: {
          keepAlive: false,
          title: "资讯列表"
        }
      },
        //资讯详情
      {
        path: '/information/detail',
        name: 'detail',
        component: () => import('@/views/information/detail'),
        meta: {
          keepAlive: false,
          title: "资讯详情"
        }
      },
      //搜索结果
      {
        path: '/information/result',
        name: 'result',
        component: () => import('@/views/information/result'),
        meta: {
          keepAlive: false,
          title: "搜索结果"
        }
      },
      // 省控线
      {
        path: '/provincialControlLine',
        name: 'provincialControlLine',
        component: () => import('@/views/provincialControlLine/provincialControlLine'),
        meta: {
          keepAlive: false,
          title: "省控线"
        }
      },
      {
        path: '/degreeAssess',
        name: 'degreeAssess',
        component: () => import('@/views/degreeAssess'),
        meta: {
          keepAlive: false,
          title: "学科评估"
        }
      },
      // 一分一段
      {
        path: '/oneScoreOneSegment',
        name: 'oneScoreOneSegment',
        component: () => import('@/views/oneScoreOneSegment/oneScoreOneSegment'),
        meta: {
          keepAlive: false,
          title: "一分一段"
        }
      },
      // 选科查询
      {
        path: '/chooseSubject',
        name: 'chooseSubject',
        component: () => import('@/views/chooseSubject/chooseSubject'),
        meta: {
          keepAlive: true,
          title: "选课查询"
        }
      },
      // 同分去向
      {
        path: '/sameScore',
        name: 'sameScore',
        component: () => import('@/views/sameScore/sameScore'),
        meta: {
          keepAlive: false,
          title: "同分去向"
        }
      },
      // 院校对比
      {
        path: '/schoolComparison',
        name: 'schoolComparison',
        component: () => import('@/views/schoolComparison/schoolComparison'),
        meta: {
          keepAlive: false,
          title: "院校对比"
        }
      },
      //录取查询
      {
        path: '/admissionInquiry',
        name: 'admissionInquiry',
        component: () => import('@/views/admissionInquiry/admissionInquiry'),
        meta: {
          keepAlive: false,
          title: "录取查询"
        }
      },
      // 高考信息
      {
        path: '/collegeInformation',
        name: 'collegeInformation',
        component: () => import('@/views/collegeInformation/collegeInformation'),
        meta: {
          keepAlive: false,
          title: "高考信息"
        }
      },
      // 高考信息
      // {
      //   path: '/mycenter',
      //   name: 'mycenter',
      //   component: () => import('@/views/mycenter/mycenter'),
      // },
      // 志愿表
      {
        path: '/volunteerForm',
        name: 'volunteerForm',
        component: () => import('@/views/volunteer/volunteerForm'),
        meta: {
          keepAlive: false,
          title: "我的志愿表"
        }
      },
      // 支付结果
      {
        path: '/okpay',
        name: 'okpay',
        component: () => import('@/views/vip/okpay'),
        meta: {
          keepAlive: false,
          title: "支付结果"
        }
      },
      // vip权益
      {
        path: '/vipp',
        name: 'vipp',
        component: () => import('@/views/vipp/vip'),
        meta: {
          keepAlive: false,
          title: "vip权益"
        }
      },
      {
        path: '/vipp/vipPay',
        name: 'vipPay',
        component: () => import('@/views/vipp/vipPay'),
        meta: {
          keepAlive: false,
          title: "vip支付"
        }
      },
      //个人中心
      {
        path: '/mycenter',
        name: 'mycenter',
        component: () => import('@/views/mycenter/index'),
        redirect: '/mycenter/personalData',
        children: [
          // 个人资料
          {
            path: '/mycenter/personalData',
            name: 'mycenter/personalData',
            component: () => import('@/views/mycenter/personalData'),
            meta: {
              keepAlive: false,
              title: "个人中心"
            }
          },
            // 学业管理
          {
            path: '/mycenter/schoolWorkManage',
            name: '/mycenter/schoolWorkManage',
            component: () => import('@/views/mycenter/schoolWorkManage'),
            meta: {
              keepAlive: false,
              title: "学业管理"
            }
          },
          // 我的订单
          {
            path: '/mycenter/myOrder',
            name: 'mycenter/myOrder',
            component: () => import('@/views/mycenter/myOrder'),
            meta: {
              keepAlive: false,
              title: "我的订单"
            }
          },
          // 我的订单
          {
            path: '/mycenter/myCard',
            name: 'mycenter/myCard',
            component: () => import('@/views/mycenter/myCard'),
            meta: {
              keepAlive: false,
              title: "我的订单"
            }
          },
          // 用户协议
          {
            path: '/mycenter/userAgreement',
            name: 'mycenter/userAgreement',
            component: () => import('@/views/mycenter/userAgreement'),
            meta: {
              keepAlive: false,
              title: "用户协议"
            }
          },
        ]
      },
      // // vip权益
      // {
      //   path: '/vip',
      //   name: 'vip',
      //   component: () => import('@/views/vip/vip'),
      //   meta: {
      //     keepAlive: false,
      //     title: "vip权益"
      //   }
      // },
    ]
  },


  {
    path: '*',
    redirect: '/404',
    hidden: true
  }, {
    path: '/404',
    component: () => import('@/views/exception/404')
  },
  //  {
  //   path: '/Login',
  //   name: 'Login',
  //   component: () => import('@/views/Login/Index'),
  //   children: []
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // console.log(to, from, savedPosition);
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.path == '/vipp') {
        return {
          x: 0,
          y: 0
        }
      }

    }
  }

})

export default router